import { get } from 'svelte/store';
import { flagsStore } from './stores';
/**
 * Ensures that Sq.Tracking module from public-web-styles is initialized.
 *
 * @returns Promise that resolves once Sq.Tracking has initialized.
 */
export function waitForTrackingInitialization() {
    const waitFor = (resolve) => {
        if (typeof window !== 'undefined' &&
            window.Sq &&
            window.Sq.Tracking &&
            window.Sq.Tracking.config &&
            window.Sq.Tracking.cdp) {
            resolve();
        }
        else {
            setTimeout(() => waitFor(resolve), 100);
        }
    };
    return new Promise(waitFor);
}
export function waitForWindow() {
    const waitFor = (resolve) => {
        if (typeof window === 'undefined') {
            setTimeout(() => waitFor(resolve), 100);
        }
        else {
            resolve();
        }
    };
    return new Promise(waitFor);
}
// TODO PWB-1210: a stopgap for PWT transition
export const filterCDPProperties = (props) => {
    const filteredProps = {};
    for (const [key, value] of Object.entries(props)) {
        if (value !== undefined) {
            filteredProps[key] = value;
        }
    }
    return filteredProps;
};
export const onActivePWTPage = (pages) => {
    if (pages === null || !Array.isArray(pages) || pages.length === 0) {
        return false;
    }
    if (pages[0] === '*') {
        return true;
    }
    return pages.includes(window.location.pathname);
};
// Tracking events with (Customer Data Platform)
export async function trackCdp({ eventName, properties = {} }) {
    await waitForWindow();
    const flags = get(flagsStore);
    const enablePwtXMS2 = flags.get('xms2-enable-pwt');
    const usePwt = Boolean(enablePwtXMS2);
    const filteredProps = filterCDPProperties(properties);
    if (usePwt) {
        window.Sq.Tracking.track({
            action: eventName,
            properties: filteredProps,
        }, { destinations: ['cdp'] });
    }
    else {
        await waitForTrackingInitialization();
        window.Sq.Tracking.cdp.track(eventName, filteredProps);
    }
}
